export default __webpack_public_path__ + "static/media/invoice_feature_discovery.6f0aee33.png";